import * as configs from "./configs"
import * as results from "./results"

export const hunt = {
    ...configs,
    ...results,
};